import {
  PostprocessingEffectName,
  PostprocessingEffectProps,
} from "@/types/vault-object-filter-types";
import { useEffect, useMemo } from "react";
import { jsx } from "react/jsx-runtime";
import { EffectAttribute, LookupTexture, LUTCubeLoader } from "postprocessing";
import { HengeLUT3DEffect } from "@/engine/viewer/postprocessing/effects/HengeLUT3DEffect";
import { useLoader } from "@react-three/fiber";

export function HengeLUT({
  strength = 1.0,
  name,
  ...props
}: PostprocessingEffectProps[typeof PostprocessingEffectName.LUT] & {
  strength?: number;
}) {
  const texture: LookupTexture = useLoader(
    LUTCubeLoader,
    `/assets/LUT/${name}`,
  );

  const effect = useMemo(
    () =>
      new HengeLUT3DEffect(texture, {
        ...props,
        strength,
      }),
    [texture, props, strength],
  );
  useEffect(() => {
    effect.dispose();
  }, [effect]);

  return jsx("primitive", {
    ...props,
    object: effect,
    attributes: EffectAttribute.CONVOLUTION,
  });
}
